import { FC } from 'react'

import { SimpleModal } from '@sequencehq/core-components'

import { useCustomerContactsContext } from 'modules/CustomerContacts/communication/internal/CustomerContacts.domain.context'
import { useContactModalForm } from '../forms/ContactModalForm/useContactModalForm'
import { ContactModalForm } from '../forms/ContactModalForm/ContactModalForm'

interface Props {
  contactId: string
  isOpen: boolean
  onClose: () => void
  onSubmit?: () => void
  onCancel?: () => void
}

export const EditContactModal: FC<Props> = ({
  contactId,
  isOpen,
  onClose,
  onSubmit,
  onCancel
}) => {
  const ctx = useCustomerContactsContext()

  const { fieldsConfig, formErrors, buttonSubmit } = useContactModalForm({
    contactId,
    customerId: ctx.queries.data.customerId,
    fieldsValues: ctx.queries.formData,
    updateFields: ctx.mutators.internal.updateForm,
    createContact: ctx.mutators.external.out.createContact,
    updateContact: ctx.mutators.external.out.updateContact
  })

  return (
    <SimpleModal
      isOpen={isOpen}
      data-testid="contacts.editModal"
      title="Edit contact"
      cancelButtonText="Cancel"
      submitButtonText="Save contact"
      submitDisabled={buttonSubmit.disabled}
      onClose={() => {
        onCancel?.()
        onClose()
      }}
      onSubmit={async () => {
        const success = await buttonSubmit.onSubmit(onSubmit)

        if (success) {
          // Close directly so the dismissal path (onCancel) doesn't run on a
          // successful submit.
          onClose()
        }

        return false
      }}
    >
      <ContactModalForm fieldsConfig={fieldsConfig} formErrors={formErrors} />
    </SimpleModal>
  )
}
